export const MESSAGE_TYPE_ERROR = 'error';
export const MESSAGE_TYPE_SUBSCRIBE = 'subscribe';
export const MESSAGE_TYPE_UNSUBSCRIBE = 'unsubscribe';

export const SUBSCRIPTION_TYPE_TRIM_PROGRESS = 'trim-progress';
export const SUBSCRIPTION_TYPE_UPLOAD_PROGRESS = 'upload-progress';

export const UPLOAD_PROGRESS_PACKETS_RECEIVED_KEY = `${SUBSCRIPTION_TYPE_UPLOAD_PROGRESS}-packetsReceived`;
export const UPLOAD_PROGRESS_PACKETS_TOTAL_KEY = `${SUBSCRIPTION_TYPE_UPLOAD_PROGRESS}-packetsTotal`;

export const HERMES_ENDPOINT = '/hermes/subscriptions';
